import { Framework } from '@/framework';
import type { DisplacementInfo } from './types';

/**
 * displacement 实例内部的状态变化事件。
 * 跨插件只能通过 Displacement.onChange 订阅，不能依赖此字符串。
 */
const DISPLACEMENT_CHANGE_EVENT = 'displacement:change';

/** displacement 实例状态监听器。 */
export type DisplacementChangeListener = (info: DisplacementInfo | null) => void;

/**
 * 光标提示插件实例。
 *
 * 本实例是提示状态的唯一数据源；业务插件通过 registration.getInstance 获取后调用
 * set/clear，视图和基础操作控制器通过 onChange 响应同一份状态。
 */
export class Displacement extends Framework {
    /** 当前提示；null 表示不展示，坐标和值语义见 DisplacementInfo。 */
    private info: DisplacementInfo | null = null;

    /** 设置提示并同步通知监听器；与当前对象引用相同时保持旧服务的不重复通知语义。 */
    set(info: DisplacementInfo) {
        if (this.info === info) return;
        this.info = info;
        this.framework.service.events.emit(DISPLACEMENT_CHANGE_EVENT, info);
    }

    /** 清空提示并同步通知监听器；当前已经为空时不重复通知。 */
    clear() {
        if (this.info === null) return;
        this.info = null;
        this.framework.service.events.emit(DISPLACEMENT_CHANGE_EVENT, null);
    }

    /** 获取当前提示快照；返回 null 表示当前没有提示。 */
    getInfo() {
        return this.info;
    }

    /** 监听提示变化；返回函数只解绑本次监听。 */
    onChange(listener: DisplacementChangeListener) {
        const handler = this.framework.service.events.on(DISPLACEMENT_CHANGE_EVENT, (info: DisplacementInfo | null) => {
            listener(info);
        });
        return () => this.framework.service.events.off(handler);
    }
}
